import { openPopin } from '../../../Services/popin';

window._define('bridge/popin', {
  open: openPopin,
});
